module.exports = __webpack_public_path__ + "static/Logo_100-6971b839a06774677d952fbb1677ea9c.png";